
<div class="d-flex  justify-content-center">
    <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
      <span class="sr-only">Loading...</span>
    </div>
</div>
<div class="d-flex  justify-content-center pt-3">
    <h3>{{ 'CLAVE.LOADING' | translate }}</h3>
</div>